const UserUpdate = (): JSX.Element => {
  return <div></div>
}

export default UserUpdate
